<template>
  <aside class="sidebar" :class="{'sidebar--collapsed': isCollapsed}">
    <!-- Menu Header -->
    <div class="sidebar-header">
      <h2 class="sidebar-title">Menu</h2>
    </div>

    <!-- Navigation Menu -->
    <nav class="sidebar-nav" @click="$event.target.closest('a') && $emit('navigate')">
      <!-- Secciones de contenido -->
      <router-link
        v-for="section in contentSections"
        :key="section.path"
        :to="section.path"
        class="sidebar-link"
        :class="{'sidebar-link--active': $route.path === section.path}"
      >
        <img :src="section.icon" width="20" height="20" :alt="section.label" class="sidebar-link-icon">
        <span v-if="!isCollapsed">{{ section.label }}</span>
      </router-link>

      <router-link
        to="/news/shorts"
        class="sidebar-link"
        :class="{'sidebar-link--active': $route.path === '/news/shorts'}"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M10 14.65v-5.3L15 12l-5 2.65zm7.77-4.33c-.77-.32-1.2-.5-1.2-.5L18 9.06c1.84-.96 2.53-3.23 1.56-5.06s-3.24-2.53-5.07-1.56L6 6.94c-1.29.68-2.07 2.04-2 3.49.07 1.42.93 2.67 2.22 3.25.03.01 1.2.5 1.2.5L6 14.93c-1.83.97-2.53 3.24-1.56 5.07.97 1.83 3.24 2.53 5.07 1.56l8.5-4.5c1.29-.68 2.06-2.04 1.99-3.49-.07-1.42-.94-2.68-2.23-3.25z"/>
        </svg>
        <span v-if="!isCollapsed">Shorts</span>
      </router-link>

      <div class="sidebar-divider"></div>

      <router-link
        to="/news/huggingface"
        class="sidebar-link sidebar-link--huggingface"
        :class="{'sidebar-link--active': $route.path === '/news/huggingface'}"
      >
        <img src="/assets/img/companies/huggingface_logo.svg" width="20" height="20" alt="HuggingFace" class="sidebar-link-icon">
        <span v-if="!isCollapsed">HuggingFace</span>
      </router-link>

      <router-link
        to="/news/leaderboard"
        class="sidebar-link"
        :class="{'sidebar-link--active': $route.path === '/news/leaderboard'}"
      >
        <span class="sidebar-section-icon" aria-hidden="true">🏆</span>
        <span v-if="!isCollapsed">Ranking LLM</span>
      </router-link>

      <div class="sidebar-divider"></div>

      <router-link
        to="/news/favorites"
        class="sidebar-link"
        :class="{'sidebar-link--active': $route.path === '/news/favorites'}"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
        <span v-if="!isCollapsed">Favoritos</span>
        <span v-if="!isCollapsed && favoritesCount > 0" class="sidebar-badge">{{ favoritesCount }}</span>
      </router-link>

      <router-link
        to="/news/history"
        class="sidebar-link"
        :class="{'sidebar-link--active': $route.path === '/news/history'}"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"/>
          <polyline points="12 6 12 12 16 14"/>
        </svg>
        <span v-if="!isCollapsed">Historial</span>
        <span v-if="!isCollapsed && historyCount > 0" class="sidebar-badge">{{ historyCount }}</span>
      </router-link>
    </nav>

    <!-- Toggle Button -->
    <button
      @click="toggleCollapse"
      class="sidebar-toggle"
      :title="isCollapsed ? 'Expandir' : 'Contraer'"
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline :points="isCollapsed ? '9 18 15 12 9 6' : '15 18 9 12 15 6'"/>
      </svg>
    </button>
    
    <!-- Profile / Login Section -->
    <div class="sidebar-profile">
      <div v-if="currentUser" class="sidebar-user">
        <img :src="currentUser.photoURL" :alt="currentUser.displayName" class="sidebar-user-avatar">
        <div v-if="!isCollapsed" class="sidebar-user-info">
          <span class="sidebar-user-name">{{ currentUser.displayName }}</span>
          <button @click="logout" class="sidebar-user-logout">Cerrar Sesión</button>
        </div>
      </div>
      <button v-else @click="login" class="sidebar-login-btn">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
           <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
           <polyline points="10 17 15 12 10 7"/>
           <line x1="15" y1="12" x2="3" y2="12"/>
        </svg>
        <span v-if="!isCollapsed">Iniciar Sesión</span>
      </button>
    </div>

  </aside>
</template>

<script>
import bookmarksService from '../../../services/bookmarks.js';
import authService from '../../../services/auth.js';

export default {
  name: 'Sidebar',
  data() {
    return {
      isCollapsed: false,
      favoritesCount: 0,
      historyCount: 0,
      currentUser: null,
      contentSections: [
        { path: '/news', label: 'Noticias', icon: '/assets/icons/news.png' },
        { path: '/news/papers', label: 'Papers', icon: '/assets/icons/papers.png' },
        { path: '/news/courses', label: 'Educación', icon: '/assets/icons/educational.png' },
        { path: '/news/forums', label: 'Foros', icon: '/assets/icons/forum.png' },
        { path: '/news/videos', label: 'Videos', icon: '/assets/icons/youtube.png' }
      ]
    };
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      this.$emit('toggle-collapse', this.isCollapsed);
    },
    updateCounts() {
      this.favoritesCount = bookmarksService.getFavorites().length;
      this.historyCount = bookmarksService.getHistory().length;
    },
    async login() {
      const result = await authService.loginWithGoogle();
      if (!result.success) {
        alert("Error al iniciar sesión. Verifica la consola o la configuración.");
      }
      // El estado se actualiza vía el listener
    },
    async logout() {
      await authService.logout();
      // El workaround para refrescar los datos locales sin usuario podría ser recargar la página
      // o limpiar en el bookmarksService. 
      // Por simplicidad en MVP, recargaremos.
      window.location.reload(); 
    }
  },
  mounted() {
    this.updateCounts();
    window.addEventListener('bookmarks-updated', this.updateCounts);
    
    // Subscribe to Auth Changes
    this.unsubscribeAuth = authService.onAuthStateChanged((user) => {
      this.currentUser = user;
      if (user) {
        // Sync bookmarks when user changes
        bookmarksService.syncUser(user);
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener('bookmarks-updated', this.updateCounts);
    if (this.unsubscribeAuth) {
      this.unsubscribeAuth();
    }
  }
};
</script>

<style scoped>
.sidebar {
  width: 240px;
  background: #1c2127;
  border-right: 1px solid #2d333b;
  display: flex;
  flex-direction: column;
  padding: 20px 12px;
  transition: width 0.3s ease;
  position: fixed;
  left: 0;
  top: 57px; /* Altura del header */
  bottom: 0;
  overflow-y: auto;
  z-index: 500;
}

.sidebar--collapsed {
  width: 80px;
}

/* Scrollbar personalizada para el sidebar */
.sidebar::-webkit-scrollbar {
  width: 4px;
}

.sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar::-webkit-scrollbar-thumb {
  background: #2d333b;
  border-radius: 2px;
}

.sidebar::-webkit-scrollbar-thumb:hover {
  background: #4a9eff;
}

/* Header Section */
.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px 10px;
  margin-bottom: 8px;
  border-bottom: 1px solid #2d333b;
}

.sidebar-title {
  font-size: 12px;
  font-weight: 600;
  margin: 0;
  color: #e1e7ef;
  text-transform: uppercase;
  letter-spacing: 1px;
  white-space: nowrap;
  overflow: hidden;
}

/* Navigation */
.sidebar-nav {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px 8px 20px;
  background: transparent;
  border-radius: 10px;
  color: #a0aec0;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.15s ease, color 0.15s ease;
  position: relative;
  white-space: nowrap;
}

.sidebar-link:hover {
  background: rgba(74, 158, 255, 0.1);
  color: #e1e7ef;
}

.sidebar-link--active {
  background: rgba(74, 158, 255, 0.12);
  color: #4a9eff;
}

.sidebar-link--active::before {
  content: '';
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 18px;
  border-radius: 2px;
  background: #4a9eff;
}

.sidebar-link svg {
  flex-shrink: 0;
}

.sidebar-link span:first-of-type:not(.sidebar-section-icon) {
  flex: 1;
}

.sidebar-badge {
  font-size: 11px;
  font-weight: 700;
  background: rgba(74, 158, 255, 0.2);
  color: #4a9eff;
  padding: 3px 8px;
  border-radius: 10px;
  min-width: 24px;
  text-align: center;
}

.sidebar-link--active .sidebar-badge {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  }

/* HuggingFace Link */
.sidebar-link--huggingface {
  position: relative;
}

.sidebar-link--huggingface:hover {
  background: rgba(255, 176, 0, 0.1);
  color: #ffb000;
}

.sidebar-link--huggingface.sidebar-link--active {
  background: rgba(255, 176, 0, 0.12);
  color: #ffb000;
}

.sidebar-link--huggingface.sidebar-link--active::before {
  background: #ffb000;
}

/* Logo de marca: conserva su color original, no se convierte a blanco */
.sidebar-link--huggingface .sidebar-link-icon {
  filter: none;
  opacity: 1;
}

.sidebar-link-icon {
  flex-shrink: 0;
  filter: brightness(0) invert(1);
  opacity: 0.75;
  transition: opacity 0.2s ease;
}

.sidebar-link:hover .sidebar-link-icon,
.sidebar-link--active .sidebar-link-icon {
  opacity: 1;
}

/* Separador entre secciones de contenido y accesos personales */
.sidebar-divider {
  height: 1px;
  background: #2d333b;
  margin: 8px 4px;
}

.sidebar-link .sidebar-section-icon {
  flex: none;
  width: 20px;
  font-size: 17px;
  line-height: 20px;
  text-align: center;
}

/* Collapsed state adjustments */
.sidebar--collapsed .sidebar-link {
  justify-content: center;
  padding: 12px;
}

.sidebar--collapsed .sidebar-link span:not(.sidebar-section-icon),
.sidebar--collapsed .sidebar-badge {
  display: none;
}

/* Toggle Button */
.sidebar-toggle {
  margin-top: auto;
  padding: 12px;
  background: transparent;
  border: 1px solid #2d333b;
  border-radius: 8px;
  color: #a0aec0;
  cursor: pointer;
  transition: all 0.2s ease;
  display: none; /* Oculto por defecto en desktop */
  align-items: center;
  justify-content: center;
}

.sidebar-toggle:hover {
  background: rgba(74, 158, 255, 0.1);
  border-color: #4a9eff;
  color: #4a9eff;
}

/* Profile Section */
.sidebar-profile {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #2d333b;
}

.sidebar-login-btn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(74, 158, 255, 0.1);
  border: none;
  border-radius: 12px;
  color: #4a9eff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.sidebar-login-btn:hover {
  background: rgba(74, 158, 255, 0.2);
}

.sidebar-user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  background: #252a33;
  border-radius: 12px;
}

.sidebar-user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.sidebar-user-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sidebar-user-name {
  color: #e1e7ef;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-user-logout {
  background: transparent;
  border: none;
  color: #f85149;
  font-size: 11px;
  padding: 0;
  margin-top: 2px;
  cursor: pointer;
  text-align: left;
}

.sidebar-user-logout:hover {
  text-decoration: underline;
}

.sidebar--collapsed .sidebar-profile {
  display: flex;
  justify-content: center;
  padding: 12px 0;
}

.sidebar--collapsed .sidebar-login-btn {
  padding: 10px;
  justify-content: center;
}

.sidebar--collapsed .sidebar-user {
  padding: 0;
  background: transparent;
}

.sidebar--collapsed .sidebar-user-info,
.sidebar--collapsed .sidebar-login-btn span {
  display: none;
}

/* Mobile - Hide sidebar by default */
@media (max-width: 768px) {
  .sidebar {
    position: fixed;
    left: -240px;
    bottom: 0;
    z-index: 500;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.3);
  }

  .sidebar--visible {
    left: 0;
  }

  .sidebar-toggle {
    display: none;
  }
}

</style>
